<template>
  <fade-transition>
    <div class="alert" :class="[`alert-${type}`]" role="alert" v-if="visible">
      <div class="alert-container">
        <div class="alert-icon text-white">
          <i :class="`now-ui-icons ${icon}`"></i>
        </div>
        <div class="alert-content text-white">
          <slot></slot>
        </div>
        <slot name="dismiss-icon" v-if="dismissible">
          <button
            type="button"
            class="close"
            aria-label="Close"
            @click="dismissAlert"
          >
            <span aria-hidden="true">
              <i class="now-ui-icons ui-1_simple-remove"></i>
            </span>
          </button>
        </slot>
      </div>
    </div>
  </fade-transition>
</template>
<script>
import { FadeTransition } from 'vue2-transitions';

export default {
  name: 'alert',
  components: {
    FadeTransition
  },
  props: {
    type: {
      type: String,
      default: 'default',
      description: 'Alert type'
    },
    dismissible: {
      type: Boolean,
      default: false
    },
    alertVisible: {
      type: Boolean,
      default: false
    },
	icon: {
	    type: String,
	    default: 'travel_info'
	},
  },
  data() {
    return {
      visible: this.alertVisible
    };
  },
  watch: {
    alertVisible(newVal) {
      this.visible = newVal;
    }
  },
  methods: {
    dismissAlert() {
      this.visible = false;
    }
  }
};
</script>

<style scoped>
.alert {
  display: flex;
  align-items: center;
  padding: 10px 15px;
  margin-bottom: 1rem;
  border-radius: 4px;
  width: 100%;
  box-sizing: border-box;
}

.alert-container {
  display: flex;
  align-items: center;
  width: 100%;
}

.alert-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  flex-shrink: 0;
}

.alert-icon i {
  font-size: 1.5rem; /* Adjust icon size as needed */
}

.alert-content {
  flex-grow: 1;
  display: flex;
  align-items: center;
  word-break: break-word;
}

.close {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
  background: none;
  border: none;
  cursor: pointer;
  flex-shrink: 0;
  padding: 0;
  font-size: 1rem;
}

.close i {
  font-size: 1rem; /* Adjust close button size as needed */
}

/* Type-specific styles (example) */
.alert-info {
  background-color: #d1ecf1;
  color: #0c5460;
  border: 1px solid #bee5eb;
}

/* Add other alert types as needed */
.alert-default {
  background-color: #f8f9fa;
  color: #212529;
  border: 1px solid #dee2e6;
}
</style>